// crm namespace — CRM Dashboard: Nudges zone; sentences are built from `type + vars`.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "nudge.action.goneQuiet": "Envoyer un e-mail de relance",
    "nudge.action.newClients": "Ajouter à la séquence de suivi",
    "nudge.action.packEnding": "Envoyer l'e-mail de renouvellement",
    "nudge.action.reviewMoment": "Demander un avis",
    "nudge.action.unconfirmedTomorrow": "Renvoyer le rappel",
    "nudge.done": "C'est fait — c'est inscrit dans l'historique du client",
    "nudge.emailTitle": "E-mail de renouvellement",
    "nudge.goneQuiet": "{name} n'a pas réservé depuis {weeks} semaines",
    "nudge.newClients.many": "{n} clients ont eu leur première séance : envoyez un suivi",
    "nudge.newClients.one": "{n} client a eu sa première séance : envoyez un suivi",
    "nudge.packEnding.many": "Il reste {n} séances dans le forfait de {name}",
    "nudge.packEnding.one": "Il reste {n} séance dans le forfait de {name}",
    "nudge.reviewMoment": "{name} a terminé {n} séances : bon moment pour demander un avis",
    "nudge.unconfirmedTomorrow": "Demain {time} avec {name} n'est pas confirmé",
    "nudge.pathwayStuck.one": "{n} apprenant est bloqué dans {pathway}",
    "nudge.pathwayStuck.many": "{n} apprenants sont bloqués dans {pathway}",
    "nudge.action.pathwayStuck": "Envoyer un encouragement",
    "nudge.emailTitleGoneQuiet": "E-mail de relance",
    "nudge.emailTitlePathwayStuck": "Message d'encouragement",
    "nudges.empty": "Rien ne requiert votre attention pour l'instant",
    "nudges.showAll": "Tout afficher",
    "nudges.title": "Coups de pouce",
  },
  en: {
    "nudge.action.goneQuiet": "Send re-engagement email",
    "nudge.action.newClients": "Add to check-in sequence",
    "nudge.action.packEnding": "Send renewal email",
    "nudge.action.reviewMoment": "Send review request",
    "nudge.action.unconfirmedTomorrow": "Resend reminder",
    "nudge.done": "Done — it is on the client's timeline",
    "nudge.emailTitle": "Renewal email",
    "nudge.goneQuiet": "{name} hasn't booked in {weeks} weeks",
    "nudge.newClients.many": "{n} clients had their first session, send a check-in",
    "nudge.newClients.one": "{n} client had their first session, send a check-in",
    "nudge.packEnding.many": "{name} has {n} sessions left in their pack",
    "nudge.packEnding.one": "{name} has {n} session left in their pack",
    "nudge.reviewMoment": "{name} has completed {n} sessions, a good time to ask for a review",
    "nudge.unconfirmedTomorrow": "Tomorrow {time} with {name} is unconfirmed",
    "nudge.pathwayStuck.one": "{n} learner is stuck in {pathway}",
    "nudge.pathwayStuck.many": "{n} learners are stuck in {pathway}",
    "nudge.action.pathwayStuck": "Send encouragement",
    "nudge.emailTitleGoneQuiet": "Re-engagement email",
    "nudge.emailTitlePathwayStuck": "Encouragement message",
    "nudges.empty": "Nothing needs you right now",
    "nudges.showAll": "Show all",
    "nudges.title": "Nudges",
  },
  es: {
    "nudge.action.goneQuiet": "Enviar correo de reactivación",
    "nudge.action.newClients": "Añadir a la secuencia de seguimiento",
    "nudge.action.packEnding": "Enviar correo de renovación",
    "nudge.action.reviewMoment": "Pedir una reseña",
    "nudge.action.unconfirmedTomorrow": "Reenviar recordatorio",
    "nudge.done": "Hecho: ya está en el historial del cliente",
    "nudge.emailTitle": "Correo de renovación",
    "nudge.goneQuiet": "{name} no ha reservado en {weeks} semanas",
    "nudge.newClients.many": "{n} clientes tuvieron su primera sesión: envía un seguimiento",
    "nudge.newClients.one": "{n} cliente tuvo su primera sesión: envía un seguimiento",
    "nudge.packEnding.many": "A {name} le quedan {n} sesiones en su bono",
    "nudge.packEnding.one": "A {name} le queda {n} sesión en su bono",
    "nudge.reviewMoment": "{name} ha completado {n} sesiones: buen momento para pedir una reseña",
    "nudge.unconfirmedTomorrow": "Mañana {time} con {name} está sin confirmar",
    "nudge.pathwayStuck.one": "{n} alumno está atascado en {pathway}",
    "nudge.pathwayStuck.many": "{n} alumnos están atascados en {pathway}",
    "nudge.action.pathwayStuck": "Enviar ánimos",
    "nudge.emailTitleGoneQuiet": "Correo de reactivación",
    "nudge.emailTitlePathwayStuck": "Mensaje de ánimo",
    "nudges.empty": "Nada requiere tu atención ahora",
    "nudges.showAll": "Ver todo",
    "nudges.title": "Avisos",
  },
};
